import React, {PureComponent} from "react";
import {connect} from "react-redux";
import Header from "../../components/Headers/Header";
import {Card, CardHeader, Container, Row} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianHistoryTranslations from "../../translations/file/history/it.history.json";
import englishHistoryTranslations from "../../translations/file/history/en.history.json";

class History extends PureComponent{
    constructor(props) {
        super(props);

        this.props.addTranslationForLanguage(italianHistoryTranslations, "it");
        this.props.addTranslationForLanguage(englishHistoryTranslations, "en");
    }

    render() {
        let fileHistory=this.props.fileHistory
        let parsedDate={
            text: <Translate id="history.date"/>,
            formatter: (cellContent, row) => (
                <>
                    {new Date(row.creationDate).toString()}
                </>
            )
        }
        const fileHistoryColumns = [
            { dataField: 'createdBy', text: <Translate id="history.actor"/>, },
            { dataField: 'status', text: <Translate id="history.status"/>, },
            { dataField: 'creationDate', text: <Translate id="history.date"/>, },
            parsedDate,
        ]
        let fileHistoryTable = this.props.files === null ? null :
            <BootstrapTable bootstrap4 headerClasses="thead-light" classes="align-items-center table-flush" keyField='id' data={ fileHistory }
                            columns={ fileHistoryColumns } pagination={ paginationFactory() }
            />

        return (
            <>
                <Header />
                <Container className="mt--5" fluid>
                    <Row>
                        <div className="col" style={{paddingBottom:"2%"}}>
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row>
                                        <div className="col">
                                            <h3 className="mb-0">
                                                <Translate id="history.title"/>
                                            </h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                {fileHistoryTable}
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

}

const mapStateToProps = state => {
    return {
        fileHistory: state.fileHistory.fileHistory,
    }
}

const mapDispatchToProps = dispatch => {
    return {

    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(History));